import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/invitation/invitation.query.gql"
import type {
  InvitationQuery,
  InvitationQueryVariables,
} from "@/v2-backoffice-client/invitation/__types__/invitation.query"

type Options = QueryHookOptions<InvitationQuery, InvitationQueryVariables>

export function useInvitationQuery(options?: Options) {
  return useQuery<InvitationQuery, InvitationQueryVariables>(query, options)
}
